import Table, { ColumnsType } from 'antd/es/table';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { findInvoiceRoute } from '../../../layout/components/SearchInvoices';
import FormHeaderTitle from '../../Invoice(Visa)/Components/FormHeaderTitle';
import {
  useAddInvoiceVendorPaymentMutation,
  useGetVendorPaymentDetailsQuery,
  useLazyGetVendorByInvoiceIdQuery,
} from '../api/endpoints/vendorPaymentEndpoints';
import {
  IAddVendorPaymentView,
  IVendorAddInvoice,
  IVendorPaymentDetails,
} from '../types/vendor.interfaces';
import { Button, Card, Col, DatePicker, Flex, Form, message, Modal, Row } from 'antd';
import dayjs from 'dayjs';
import { SelectInvoiceFor_V_Payment } from '../../../components/common/FormItem/SelectCustomFeilds';
import PaymentVendorList from './PaymentVendorList';
import { useWatch } from 'antd/es/form/Form';

type Props = {
  id: string | undefined;
  singleData: IAddVendorPaymentView;
};
const VendorPaymentViewDetails = (props: Props) => {
  const { id, singleData } = props;
  const { data } = useGetVendorPaymentDetailsQuery(Number(id));
  const [form] = Form.useForm();
  const paymentTo = singleData?.vpay_payment_to;
  const [open, setOpen] = useState(false);
  const [addInvoice, { isSuccess, isLoading }] = useAddInvoiceVendorPaymentMutation();
  const [getVendorByInvoiceId, { data: vendorByInvData }] = useLazyGetVendorByInvoiceIdQuery();
  let invoice_id = useWatch('invoice_id', form);
  let vendors = useWatch('specific_inv_vendors', form);

  const paymentTotal = Number(singleData?.payment_amount) || 0;
  const invoiceClientTotal = data?.data?.reduce((acc: number, item: IVendorPaymentDetails) => {
    return acc + Number(item.invendorpay_amount);
  }, 0);
  const formInvoiceTotal = vendors?.reduce((acc: number, item: any) => {
    return acc + Number(item?.specific_inv_amount || 0);
  }, 0);

  const receiptRemainingTotal = paymentTotal - (invoiceClientTotal || 0);

  useEffect(() => {
    getVendorByInvoiceId(invoice_id);
  }, [invoice_id]);
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
  };
  const onFinish = (values: any) => {
    if (receiptRemainingTotal < formInvoiceTotal) {
      message.error('Invoice Amount can not greater than Payment Remaining Total');
      return;
    }
    const { specific_inv_vendors, payment_date, invoice_id } = values;
    const body: IVendorAddInvoice = {
      payment_date: dayjs(payment_date).format('YYYY-MM-DD'),
      vendors: specific_inv_vendors?.map((item: any) => ({
        invoice_id: invoice_id,
        comb_vendor: item.comb_vendor_specific_invoice,
        vendor_amount: item.specific_inv_amount,
      })),
    };
    addInvoice({ body, id: Number(id) });
  };

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      message.success('Invoice Added Successfully');
      form.resetFields();
    }
  }, [isSuccess]);

  const vendorPaymentCostColumn: ColumnsType<IVendorPaymentDetails> = [
    { title: 'SL', render: (_, data, index) => <> {index + 1} </> },
    {
      title: 'Vendor Name',
      key: 'vendor_name',
      dataIndex: 'vendor_name',
    },
    {
      title: 'Vendor Mobile',
      key: 'vendor_mobile',
      dataIndex: 'vendor_mobile',
    },
    {
      title: 'Payment Amount',
      key: 'invendorpay_amount',
      dataIndex: 'invendorpay_amount',
    },
    {
      title: 'Invoice No',
      key: 'invoice_no',
      dataIndex: 'invoice_no',
      render: (_, data) => (
        <Link
          to={
            '../' +
            findInvoiceRoute(data.invoice_category_id) +
            '/' +
            'details' +
            '/' +
            data.invoice_id
          }
          state={location.pathname}
        >
          {data.invoice_no}
        </Link>
      ),
    },
    {
      title: 'Total Purchase',
      key: 'invoice_total_vendor_price',
      dataIndex: 'invoice_total_vendor_price',
    },
  ];
  return (
    <div
      className='my-20'
      style={{ backgroundColor: '#FFFFFF', padding: '20px', minWidth: '100vh' }}
    >
      <Row>
        <Col span={21}>
          <FormHeaderTitle title='PAYMENT DETAILS' />
        </Col>
        {paymentTo === 'ADVANCE' && (
          <Col span={3} style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
            <Button onClick={showModal} type='primary'>
              Add Invoice
            </Button>
          </Col>
        )}
      </Row>
      <Modal
        forceRender
        width={1000}
        style={{ top: 20 }}
        title='Add Invoice'
        open={open}
        onOk={handleOk}
        footer={null}
        // okButtonProps={{ loading: isLoading }}
        onCancel={handleCancel}
      >
        <Form
          layout='vertical'
          onFinish={onFinish}
          onFinishFailed={() => message.error('Submission Failed')}
          form={form}
          initialValues={{
            payment_date: dayjs(),
          }}
        >
          <Card style={{ margin: '10px 0px' }}>
            <Row gutter={[10, 10]}>
              <SelectInvoiceFor_V_Payment
                name='invoice_id'
                label='Select Invoice'
                required
                size={8}
                mdSize={8}
                smSize={8}
              />
              <Col span={8}>
                <Form.Item label='Payment Date' name={'payment_date'}>
                  <DatePicker required style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <p
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '30px',
                    marginLeft: '12px',
                    fontWeight: 'bold',
                    fontSize: '16px',
                  }}
                >
                  Remaining Amount : {receiptRemainingTotal}
                </p>
              </Col>
              <PaymentVendorList form={form} vendorByInvData={vendorByInvData} />
            </Row>
          </Card>

          <Button type='primary' htmlType='submit' loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
      <Table
        size='small'
        bordered
        rowKey={(e) => e.invendorpay_id}
        className='invoiceBillingTable'
        rowClassName={'invoiceBillingTd'}
        dataSource={data?.data || []}
        columns={vendorPaymentCostColumn}
        pagination={false}
        style={{ marginBottom: '20px' }}
      />
    </div>
  );
};

export default VendorPaymentViewDetails;
